import { Link } from "react-router-dom";
import type { AppUser, UserStatus } from "@/types";

const STATUS_CHIP: Record<UserStatus, string> = {
  Active: "bg-success-soft text-success",
  Invited: "bg-warning-soft text-warning",
  Suspended: "bg-danger-soft text-danger",
};

function StatusBadge({ status }: { status: UserStatus }) {
  const chip = STATUS_CHIP[status] ?? "bg-disabled-soft text-disabled";
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-[3px] text-[10px] font-semibold leading-none whitespace-nowrap ${chip}`}>
      {status}
    </span>
  );
}

export function UserRow({ user }: { user: AppUser }) {
  return (
    <tr className="border-b border-line last:border-b-0">
      <td className="px-4 py-[9px]">
        <Link to={`/admin/users/${user.id}`} className="text-[11.5px] font-semibold text-primary hover:underline">
          {user.name}
        </Link>
      </td>
      <td className="px-4 py-[9px] whitespace-nowrap text-[11.5px] text-ink">{user.email}</td>
      <td className="px-4 py-[9px] whitespace-nowrap text-[11.5px] text-ink">{user.role}</td>
      <td className="px-4 py-[9px] whitespace-nowrap text-[11.5px] text-ink">
        {user.groups.length > 0 ? user.groups.join(", ") : "—"}
      </td>
      <td className="px-4 py-[9px] whitespace-nowrap text-[11.5px] text-ink">{user.mfa || "—"}</td>
      <td className="px-4 py-[9px]">
        <StatusBadge status={user.status} />
      </td>
      <td className="px-4 py-[9px] whitespace-nowrap text-[11.5px] text-ink">{user.lastActive}</td>
    </tr>
  );
}